import React, { createContext, useState } from 'react';

export const InputCoreCard = createContext(null);

export type Stats = {
    hp: number;
    atk: number;
    def: number;
    critrate: number;
    critdmg: number;
    dbw: number;
    eeb: number;
    orb: number;
    os: number;
}

export type TeamStats = {
    memory: string;
    level: number;
    ascended: boolean;
    rank: number;
    hp: number;
    atk: number;
    def: number;
    critrate: number;
    critdmg: number;
    dbw: number;
    eeb: number;
    orb: number;
    os: number;
    core1: Stats;
    core2: Stats;
    filename: string;
};

export type Teams = {
    companion: string;
    character: string;
    affinity: number;
    solar1: TeamStats;
    solar2: TeamStats;
    lunar1: TeamStats;
    lunar2: TeamStats;
    lunar3: TeamStats;
    lunar4: TeamStats;
    filename: string;
}

export const defaultStats: Stats = {
    hp: 0,
    atk: 0,
    def: 0,
    critrate: 0,
    critdmg: 0,
    dbw: 0,
    eeb: 0,
    orb: 0,
    os: 0
}

export const defaultTeamStats: TeamStats = {
    memory: "",
    level: 1,
    ascended: false,
    rank: 0,
    hp: 0,
    atk: 0,
    def: 0,
    critrate: 0,
    critdmg: 0,
    dbw: 0,
    eeb: 0,
    orb: 0,
    os: 0,
    core1: defaultStats,
    core2: defaultStats,
    filename: ""
};

export const defaultTeams: Teams = {
    companion: "",
    character: "",
    affinity: 0,
    solar1: defaultTeamStats,
    solar2: defaultTeamStats,
    lunar1: defaultTeamStats,
    lunar2: defaultTeamStats,
    lunar3: defaultTeamStats,
    lunar4: defaultTeamStats,
    filename: ""
}

export const CoreCardProvider = ({children}) => {
    const [coreList, setCoreList] = useState([]);
    const [tagCIndex, setTagCIndex] = useState([]);
    const [tagBIndex, setTagBIndex] = useState([]);
    const [team, setTeam] = useState<Teams>(defaultTeams);

    return (
        <InputCoreCard.Provider value={{ coreList, setCoreList, tagCIndex, setTagCIndex, tagBIndex, setTagBIndex, team, setTeam }}>
            {children}
        </InputCoreCard.Provider>
    );
};